export default class BaseControl
{

  /**
   * @param jQuery el
   * @return Object {name: String, value: String}
   */
  getCurrentStateForEl(el)
  {
    var _el = el.find('.fs-date-picker, .fs-dateTime-picker')
    if(_el.length != 0)
    {
      el = _el;
    }

    var val = el.val();
    var name = el.attr('name');
    var isRequired = false;
    var label = $(`label[for='${$(el).attr('id')}']`);

    if(label !== undefined)
    {
      isRequired = label.hasClass('isRequired');
    }

    return {name: name, value: val, isRequired: isRequired};
  }
}



// WEBPACK FOOTER //
// ./client-side/MetadataLogic/BaseControl.js